import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AppService } from 'src/app/app.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderItemsUtilsService } from 'src/app/order-items/order-items-util.service';

import * as _ from 'lodash';

@Component({
    selector: 'app-offer-item-dialog',
    templateUrl: './offer-item-dialog.component.html',
    styleUrl: './offer-item-dialog.component.scss',
    standalone: false
})
export class OfferItemDialogComponent implements OnDestroy {
	args;
	currentItem;

	constructor(
		public dialogRef: MatDialogRef<OfferItemDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public appService: AppService,
		public orderService: OrderService,
		public orderUtils: OrderItemsUtilsService,
	) {
		this.args = {
			mode: "item",
			group: this.data.group,
			groupItem: this.data.groupItem,
			isEditSGItem: this.data.isEditSGItem,
			currentItemPrice: this.data.currentItemPrice || 0
		}
		if (this.data.isEditSGItem) {
			this.currentItem = _.cloneDeep(this.data.currentItem);
		} else {
			this.currentItem = this.data.currentItem;
		}
		this.orderUtils.validateItem(this.currentItem, [], true);
	}

	ngOnDestroy() {

	}

	clearSelection() {
		this.dialogRef.close({
			isClear: true
		});
	}

	submit() {
		var arrErrors = [];
		if (this.orderUtils.validateItem(this.currentItem, arrErrors)) {
			if (this.args.isEditSGItem) {
				this.args.groupItem._item = this.currentItem;
			}
			this.dialogRef.close({
				group: this.args.group,
				groupItem: this.args.groupItem
			});
		} else {
			this.appService.alert({ content: arrErrors[0] });
		}
	}

	cancel() {
		this.dialogRef.close();
	}
}

